import script from "./Check.vue?vue&type=script&setup=true&lang=js"
export * from "./Check.vue?vue&type=script&setup=true&lang=js"

import "./Check.vue?vue&type=style&index=0&id=327f079a&lang=scss"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QRadio,QFooter,QBtn});
